export const initialState = {
  serviceOrderToken: '',
  paymentOrderToken: '',
  isLoading: false,
};
